import { render, staticRenderFns } from "./EsgBaseTable.vue?vue&type=template&id=858baaca&scoped=true"
import script from "./EsgBaseTable.vue?vue&type=script&lang=js"
export * from "./EsgBaseTable.vue?vue&type=script&lang=js"
import style0 from "./EsgBaseTable.vue?vue&type=style&index=0&id=858baaca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858baaca",
  null
  
)

export default component.exports